const staticConfig = {
  tileServer: {
    url: "https://cyberjapandata.gsi.go.jp"
  }
};

const cognitoConfig = {
  Region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_9gnwxKmjC",
  ClientId: "tm968p7s96v8gov9ddu65kitk",
  IdentityPoolId: "ap-northeast-1:91be1105-9696-4473-82a9-7ca25356eb96"
};

const alertConfig = {
  Point: "JPDE",
  Cities: ["0721100"],
  Rivers: []
};

export { staticConfig, cognitoConfig, alertConfig };
